import React from "react";
import PlusTwo from "./sections/plustwo";
import CTEVT from "./sections/ctevt";
import Alevel from "./sections/alevel";
import Foreign from "./sections/foreign";
function Regular({ section }) {
  return (
    <div>
      {section === "+2" ? (
        <PlusTwo />
      ) : section === "alevel" ? (
        <Alevel />
      ) : section === "ctevt" ? (
        <CTEVT />
      ) : (
        <Foreign />
      )}
    </div>
  );
}

export default Regular;
